import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useUiText } from '@clavian/i18n/react';
import { cx } from '../lib/cx.js';
export function initialsOf(name) {
    const parts = name.trim().split(/\s+/).filter(Boolean);
    if (parts.length === 0)
        return '?';
    const first = parts[0]?.[0] ?? '';
    const last = parts.length > 1 ? (parts.at(-1)?.[0] ?? '') : '';
    return `${first}${last}`.toUpperCase();
}
export function Avatar({ name, src, size = 'md', presence, decorative = false, className, }) {
    const t = useUiText();
    const accessibleName = presence ? `${name}, ${t(`presence.${presence}`)}` : name;
    return (_jsxs("span", { className: cx('clav-avatar', `clav-avatar--${size}`, className), role: decorative ? undefined : 'img', "aria-label": decorative ? undefined : accessibleName, "aria-hidden": decorative || undefined, children: [src ? (_jsx("img", { className: "clav-avatar__image", src: src, alt: "" })) : (_jsx("span", { className: "clav-avatar__initials", children: initialsOf(name) })), presence ? _jsx("span", { className: cx('clav-avatar__presence', `clav-avatar__presence--${presence}`) }) : null] }));
}
//# sourceMappingURL=avatar.js.map